module.exports = __webpack_public_path__ + "img/grade.e38b69d1.svg";